import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { injectIntl } from 'react-intl';

import UpgradePlanButton from '../../UpgradePlanButton';

class AdminFileStatusesHeader extends PureComponent {
  render() {
    const {
      intl,
      statusesVisible,
      statusesTotal,
      loading,
      handleAddStatus,
    } = this.props;

    return (
      <header id="statuses-list-header" className="page-header with-upgrade-button">
        <h3>
          {intl.formatMessage({ defaultMessage: 'File statuses' })}
        </h3>
        <UpgradePlanButton feature="file-status" />
        <div className="header-actions users-actions">
          <div className="items-displaying users-displaying">
            {(!loading && statusesTotal > 0) && (
              <span>
                {intl.formatMessage(
                  { defaultMessage: '{statusesVisible} of {statusesTotal} statuses' },
                  { statusesVisible, statusesTotal },
                )}
              </span>
            )}
          </div>
          <div className="button-wrapper">
            <Button color="primary" onClick={handleAddStatus}>
              <i className="fas fa-plus" />
              <span>
                {intl.formatMessage({ defaultMessage: 'Add file status' })}
              </span>
            </Button>
          </div>
        </div>
      </header>
    );
  }
}

AdminFileStatusesHeader.propTypes = {
  intl: PropTypes.object.isRequired,
  statusesVisible: PropTypes.string.isRequired,
  statusesTotal: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  handleAddStatus: PropTypes.func.isRequired,
};

export default injectIntl(AdminFileStatusesHeader);
